import { SellerPermissionDisplayModal } from './SellerPermissionDisplayModal';

export const getSellerPermissionDisplayModalConfig = (
  roleIds?: number[] | null
) => ({
  children: <SellerPermissionDisplayModal roleIds={roleIds} />,
  clickOutsideToClose: true,
  size: 'slide-in',
});
